import { Reveal, Chapter, TrackCorner } from "./primitives";
import { useLanguage } from "../../i18n/LanguageContext";

export const About = () => {
  const { t } = useLanguage();
  const A = t.about;
  return (
  <section id="about" className="relative overflow-hidden bg-white py-24 lg:py-36" data-testid="about-section">
    <div className="pointer-events-none absolute -right-24 -top-24 text-kn-navy/[0.05]">
      <TrackCorner className="h-[320px] w-[320px] rotate-90" />
    </div>
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <Chapter index="07" label={A.chapter} />
      </Reveal>
      <div className="mt-10 grid gap-14 lg:grid-cols-2">
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl italic leading-[1.15] text-kn-navy sm:text-5xl">
            {A.h2}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-base leading-relaxed text-kn-navy/65">
            {A.body}
          </p>
          <div className="mt-10 divide-y divide-kn-navy/10 border-y border-kn-navy/10">
            {A.principles.map((p, i) => (
              <div key={p} className="flex items-center justify-between py-4" data-testid={`about-principle-${i}`}>
                <span className="text-sm font-semibold text-kn-navy/70">{p}</span>
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-kn-navy/40">0{i + 1}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>

      <Reveal className="mt-16">
        <div className="relative h-64 overflow-hidden rounded-2xl lg:h-80" data-testid="about-image">
          <img src="/images/about-workforce.jpg" alt="The workforce behind sport" loading="lazy" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-kn-navy/70 via-kn-navy/20 to-transparent" />
          <p className="absolute bottom-6 left-8 font-mono text-[11px] tracking-[0.28em] uppercase text-white/85">
            The people behind the game
          </p>
        </div>
      </Reveal>
    </div>
  </section>
  );
};

export const ClosingCta = () => {
  const { t } = useLanguage();
  return (
  <section className="noise relative overflow-hidden bg-kn-navy py-24 lg:py-32" data-testid="closing-cta">
    <img src="/images/closing-crowd.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
    <div
      className="pointer-events-none absolute inset-0"
      style={{ background: "radial-gradient(900px 500px at 50% 120%, rgba(46,197,230,0.18), transparent 65%)" }}
    />
    <div className="relative mx-auto max-w-7xl px-6 text-center lg:px-10">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.32em] uppercase text-kn-cyan">{t.closing.eyebrow}</p>
        <h2 className="mx-auto mt-6 max-w-3xl text-4xl font-semibold leading-[1.1] tracking-tight text-white sm:text-5xl">
          {t.closing.h2}
        </h2>
        <div className="mx-auto mt-16 flex max-w-3xl flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 font-mono text-[11px] tracking-[0.18em] uppercase text-white/40 sm:flex-row">
          <a href="https://www.krida.me" target="_blank" rel="noopener noreferrer" data-testid="closing-website" className="transition-colors duration-300 hover:text-kn-cyan">www.krida.me</a>
          <a href="mailto:hello@krida.me" data-testid="closing-email" className="transition-colors duration-300 hover:text-kn-cyan">hello@krida.me</a>
          <span data-testid="closing-office">Singapore · Malaysia · India</span>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
